import { VerticalTranslationContext } from './Contexts';
import { useContext } from 'react';

const editableTableDivStyle = {
  overflow:'auto',
  minHeight:0,
  paddingLeft:50,
  paddingRight:50,
  minWidth:0,
}


function VerticalResizeSpace(){
  const verticalTranslation = useContext(VerticalTranslationContext);

  let height = verticalTranslation?.y;
  if( height && height > 0 ){
    return (
      <div style={{height}}/>
    )
  }
  return null;

}

export default function GridScrollContainer({
  editableTableRef,
  children
}){

  return (
    <div 
      ref={editableTableRef}
      class="scroll-shadows-vertical "
      style={editableTableDivStyle}>
      {children}
      <VerticalResizeSpace/>
    </div>
  )


}
